import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Flex,
  HStack,
  Input,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Badge,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';
import axiosInstance from '../../../api/AxiosInstance';
import FormularioCapacitacion from './FormularioCapacitacion';
import ModalInscripciones from './ModalInscripciones';

const TablaCapacitaciones: React.FC = () => {
  const toast = useToast();
  const { isOpen: isOpenVer, onOpen: onOpenVer, onClose: onCloseVer } = useDisclosure();
  const { isOpen: isOpenNuevo, onOpen: onOpenNuevo, onClose: onCloseNuevo } = useDisclosure();
  const { isOpen: isOpenInscripciones, onOpen: onOpenInscripciones, onClose: onCloseInscripciones } = useDisclosure();

  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [data, setData] = useState<any[]>([]);
  const [cargando, setCargando] = useState(false);
  const [busqueda, setBusqueda] = useState('');

  const fetchData = async () => {
    setCargando(true);
    try {
      const res = await axiosInstance.get('/turismo/capacitaciones');
      setData(res.data || []);
    } catch {
      setData([]);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  const datosFiltrados = data.filter((item) =>
    busqueda
      ? item.nombre?.toLowerCase().includes(busqueda.toLowerCase()) ||
        item.tipo?.toLowerCase().includes(busqueda.toLowerCase())
      : true
  );

  const handleVer = (item: any) => { setSelectedItem(item); onOpenVer(); };
  const handleGuardado = () => { onCloseNuevo(); fetchData(); };
  const handleInscripciones = (item: any) => { setSelectedItem(item); onOpenInscripciones(); };

  const handleConcluir = async (item: any) => {
    try {
      await axiosInstance.post(`/turismo/capacitaciones/${item.id}/concluir`);
      toast({ title: 'Capacitacion concluida', status: 'success', duration: 3000 });
      fetchData();
    } catch {
      toast({ title: 'Error al concluir', status: 'error', duration: 3000 });
    }
  };

  const formatFechaHora = (v: string) => (v ? new Date(v).toLocaleString('es-MX') : '-');

  return (
    <Box>
      <Flex mb={4} justify="space-between" align="center" flexWrap="wrap" gap={3}>
        <HStack spacing={3} flexWrap="wrap">
          <Input
            placeholder="Buscar por nombre o tipo..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            size="sm"
            w={{ base: 'full', md: '260px' }}
          />
        </HStack>
        <Button size="sm" leftIcon={<AddIcon />} bg="#5b182b" color="white" _hover={{ bg: '#691f30' }} onClick={onOpenNuevo}>
          Nueva capacitacion
        </Button>
      </Flex>

      <Box overflowX="auto" borderRadius="md" boxShadow="md" bg="white">
        <Table variant="simple" size="sm">
          <Thead bg="#5b182b">
            <Tr>
              <Th color="white" fontSize="xs">Nombre</Th>
              <Th color="white" fontSize="xs">Tipo</Th>
              <Th color="white" fontSize="xs">Fecha hora</Th>
              <Th color="white" fontSize="xs">Cupo</Th>
              <Th color="white" fontSize="xs">Estatus</Th>
              <Th color="white" fontSize="xs">Acciones</Th>
            </Tr>
          </Thead>
          <Tbody>
            {cargando ? (
              <Tr><Td colSpan={6} textAlign="center" py={8}><Text color="gray.500">Cargando...</Text></Td></Tr>
            ) : datosFiltrados.length === 0 ? (
              <Tr><Td colSpan={6} textAlign="center" py={8}><Text color="gray.400">Sin registros</Text></Td></Tr>
            ) : (
              datosFiltrados.map((item, idx) => (
                <Tr key={item.id} bg={idx % 2 === 0 ? 'white' : 'gray.50'} _hover={{ bg: '#f7efe8' }}>
                  <Td maxW="220px"><Text noOfLines={1} title={item.nombre}>{item.nombre}</Text></Td>
                  <Td>{item.tipo || '-'}</Td>
                  <Td>{formatFechaHora(item.fechaHora)}</Td>
                  <Td>{item.cupo ?? '-'}</Td>
                  <Td><Badge colorScheme={item.estatus === 'concluido' ? 'blue' : 'green'}>{item.estatus}</Badge></Td>
                  <Td>
                    <HStack spacing={1} flexWrap="wrap">
                      <Button size="xs" colorScheme="blue" variant="outline" onClick={() => handleVer(item)}>Ver</Button>
                      <Button size="xs" colorScheme="teal" variant="outline" onClick={() => handleInscripciones(item)}>Inscripciones</Button>
                      {item.estatus !== 'concluido' && (
                        <Button size="xs" colorScheme="blue" variant="solid" onClick={() => handleConcluir(item)}>Concluir</Button>
                      )}
                    </HStack>
                  </Td>
                </Tr>
              ))
            )}
          </Tbody>
        </Table>
      </Box>

      <Modal isOpen={isOpenVer} onClose={onCloseVer} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="xl" overflow="hidden">
          <ModalHeader borderBottom="1px solid" borderColor="gray.200" color="#5b182b" bg="gray.50">Detalle de capacitacion</ModalHeader>
          <ModalBody py={5} bg="white">
            {selectedItem && <FormularioCapacitacion modo="view" data={selectedItem} />}
          </ModalBody>
          <ModalFooter borderTop="1px solid" borderColor="gray.100" bg="gray.50">
            <Button onClick={onCloseVer}>Cerrar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenNuevo} onClose={onCloseNuevo} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="xl" overflow="hidden">
          <ModalHeader borderBottom="1px solid" borderColor="gray.200" color="#5b182b" bg="gray.50">Nueva capacitacion</ModalHeader>
          <ModalBody py={5} bg="white">
            <FormularioCapacitacion modo="new" onGuardado={handleGuardado} onCancelar={onCloseNuevo} />
          </ModalBody>
        </ModalContent>
      </Modal>

      {selectedItem && (
        <ModalInscripciones
          isOpen={isOpenInscripciones}
          onClose={onCloseInscripciones}
          capacitacion={selectedItem}
        />
      )}
    </Box>
  );
};

export default TablaCapacitaciones;


